import { theme } from "../../../utils/styles";

const LayoutStyles = {
  main: {
    [theme.breakpoints.up("md")]: {},
  },
} as const;

export default LayoutStyles;
